import React from 'react';
import { Button } from '@mui/material';
import ReactExport from 'react-export-excel';
import { Icon } from '@iconify/react';
import { terminal_id_recargas, terminal_id_servicios } from '../../../../config';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;

const setValueCurrentControlNumber = (value) => {
  if (value === 'null') {
    return '';
  }
  if (typeof value === 'object') {
    return '';
  }
  return value;
};

function ReportRecServHugo({ dataList = [] }) {
  console.log(terminal_id_recargas, terminal_id_servicios);
  return (
    <ExcelFile
      element={
        <Button variant="contained" startIcon={<Icon icon="eva:file-text-fill" />}>
          Reporte
        </Button>
      }
    >
      <ExcelSheet data={dataList} name="Reporte">
        <ExcelColumn label="Usuario" value="user_name" />
        <ExcelColumn label="Nombre" value="name" />
        <ExcelColumn label="Date_Time" value="TransactionDateTime" />

        <ExcelColumn label="Num. referencia" value="accountId" />
        <ExcelColumn label="Num. autorizacion" value={(col) => setValueCurrentControlNumber(col.CarrierControlNo)} />
        <ExcelColumn label="Monto" value={(col) => (col.providerAmount ? col.providerAmount : col.totalAmount)} />
        <ExcelColumn label="Status" value="status" />
        {/* <ExcelColumn label="Invoice_Id" value={(col) => (col.is_married ? 'Married' : 'Single')} /> */}
      </ExcelSheet>
    </ExcelFile>
  );
}

export default ReportRecServHugo;
